import constants from "../utils/constants";
import TokenNeeded from "../utils/TokenNeeded";

class BalootUserControllerV2 {
  static shahkarCheck(data) {
    return TokenNeeded.request({
      method: "post",
      url: constants.baloot.userControllerV2 + "profile/check",
      params: {
        nationalId: data.nationalId,
      },
    });
  }
  static sejamStatusCheck(data) {
    return TokenNeeded.request({
      method: "post",
      url: constants.baloot.userControllerV2 + "profile/status",
      params: {
        nationalId: data.nationalId,
      },
    });
  }
  static sejamOtpCheck(data) {
    return TokenNeeded.request({
      method: "post",
      url: constants.baloot.userControllerV2 + "profile/status/otp",
      params: {
        nationalId: data.nationalId,
        otp: data.otp,
      },
    });
  }

  static getSejamStatus(data) {
    return TokenNeeded.request({
      method: "get",
      url: constants.baloot.userControllerV2 + "profile/status",
      params: {
        updated: data.updated ? "true" : "false",
      },
    });
  }
  static sejamStatusCheckPut(data) {
    return TokenNeeded.request({
      method: "put",
      url: constants.baloot.userControllerV2 + "profile/status",
    });
  }
  static sejamOtpCheckPut(data) {
    return TokenNeeded.request({
      method: "put",
      url: constants.baloot.userControllerV2 + "profile/status/otp",
      params: {
        otp: data.otp,
      },
    });
  }
  static postReferralCode(data) {
    return TokenNeeded.request({
      method: "post",
      url: constants.baloot.userControllerV2 + "campaigns/referral",
      params: {
        referralCode: data.referralCode,
      },
    });
  }

  static userStats() {
    return TokenNeeded.request({
      method: "get",
      url: constants.baloot.userControllerV2 + "stats",
    });
  }

  static walletTransactions(data) {
    return TokenNeeded.request({
      method: "get",
      url: constants.baloot.userControllerV2 + "wallets/transactions",
      params: {
        page: data.page || 0,
        size: data.size || 20,
      },
    });
  }

  static getFinancialAssetInvestPre(data) {
    return TokenNeeded.request({
      method: "get",
      url:
        constants.baloot.userControllerV2 +
        "investments/" +
        data.assetId.toString() +
        "/invest/pre",
    });
  }

  static getPersonalInfo() {
    return TokenNeeded.request({
      method: "get",
      url: constants.baloot.userControllerV2 + "account/personal",
    });
  }

  static voucher(data) {
    return TokenNeeded.request({
      method: "put",
      url: constants.baloot.userControllerV2 + "voucher",
      params: {
        code: data.code,
      },
    });
  }

  static getCampaignReferral() {
    return TokenNeeded.request({
      method: "get",
      url: constants.baloot.userControllerV2 + "campaigns/referral",
    });
  }

  static getCampaignStep(data) {
    return TokenNeeded.request({
      method: "get",
      url: `${constants.baloot.userControllerV2}campaigns/${data.campaignId}/steps`,
    });
  }

  static getCampaignDetails(data) {
    return TokenNeeded.request({
      method: "get",
      url: `${constants.baloot.userControllerV2}campaigns/${data.campaignId}/detail`,
    });
  }

  static getUserInvestmentHistory(data) {
    return TokenNeeded.request({
      method: "get",
      url: constants.baloot.userControllerV2 + "investments/stats/past",
      params: {
        page: data.page || 0,
        size: data.size || 20,
      },
    });
  }

  static getUserInvestmentToday(data) {
    return TokenNeeded.request({
      method: "get",
      url: constants.baloot.userControllerV2 + "investments/stats/today",
    });
  }

  static sync() {
    return TokenNeeded.request({
      method: "get",
      url: constants.baloot.userControllerV2 + "sync",
    });
  }

  static preCashoutInfo(data) {
    return TokenNeeded.request({
      method: "get",
      url:
        constants.baloot.userControllerV2 +
        "wallets/" +
        data.walletId.toString() +
        "/withdrawal/pre",
    });
  }
}

export default BalootUserControllerV2;
